module.exports = __webpack_public_path__ + "media/100.4360f4d9.mp3";